module.exports = __webpack_public_path__ + "8f2e39479ea5a94ffc5ddd8f59e388ae.svg";